import { FC, useCallback } from 'react';

interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
    leftLabel?: string;
    disabled?: boolean;
    rightLabel?: string;
}

const CheckboxComponent: FC<Props> = ({ checked, onChange, leftLabel = '', rightLabel = '', disabled = false }) => {
    const handleOnClick = useCallback(() => {
        if (!disabled) {
            onChange(!checked);
        }
    }, [disabled, checked]);

    return (
        <div className="br_checkboxComponent">
            <input type="checkbox" onClick={handleOnClick} disabled={disabled} checked={checked} readOnly />
            <label onClick={handleOnClick}>
                {leftLabel ? leftLabel : ''}
                <span></span>
                {rightLabel ? rightLabel : ''}
            </label>
        </div>
    );
};

export default CheckboxComponent;
